import React from 'react';

const ReusableCheckbox = ({
  id,
  name,
  label,
  labelElement,
  required = false,
  checked,
  onChange,
  className = '',
  helpText = '',
  disabled = false,
}) => {
  return (
    <div className={`mb-2 ${className}`}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <input
          id={id || name}
          name={name}
          type="checkbox"
          checked={checked}
          onChange={onChange}
          required={required}
          disabled={disabled}
        />
        {label && (
          <label htmlFor={id || name}>
            {labelElement ? labelElement : label}{required && <span className="text-danger ms-1">*</span>}
          </label>
        )}
        {!label && labelElement && (
          <label htmlFor={id || name}>
            {labelElement}{required && <span className="text-danger ms-1">*</span>}
          </label>
        )}
      </div>
      {helpText && (
        <div className="form-text" style={{ color: '#c33' }}>{helpText}</div>
      )}
    </div>
  );
};

export default ReusableCheckbox;


